import React, { useState, useEffect } from 'react';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@material-ui/core';

interface AddToAllButtonProps {
  onConfirm: (amount: number) => void;
  loading?: boolean;
  label?: string;
  open?: boolean;
  onClose?: () => void;
}

const AddToAllButton: React.FC<AddToAllButtonProps> = ({ onConfirm, loading = false, label = 'Add to All', open, onClose }) => {
  const [internalOpen, setInternalOpen] = useState(false);
  const [amount, setAmount] = useState('0');

  const isControlled = open !== undefined && onClose !== undefined;
  const actualOpen: boolean = isControlled ? !!open : internalOpen;
  const handleOpen = () => {
    if (isControlled) {
    } else {
      setInternalOpen(true);
    }
  };
  const handleClose = () => {
    setAmount('0');
    if (isControlled) {
      onClose && onClose();
    } else {
      setInternalOpen(false);
    }
  };
  const handleConfirm = () => {
    onConfirm(Number(amount) || 0);
    handleClose();
  };
  useEffect(() => {
    if (!actualOpen) setAmount('0');
  }, [actualOpen]);
  return (
    <>
      {!isControlled && (
        <Button onClick={handleOpen} disabled={loading} variant="contained" color="primary">
          {label}
        </Button>
      )}
      <Dialog open={actualOpen} onClose={handleClose} maxWidth="xs" fullWidth PaperProps={{ style: { minWidth: 260, maxWidth: 320 } }}>
        <DialogTitle>Amount to add to all items</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            type="number"
            fullWidth
            value={amount}
            onChange={(e) => setAmount(e.target.value.replace(/[^0-9]/g, ''))}
            inputProps={{ min: 0 }}
            disabled={loading}
            size="small"
            style={{ maxWidth: 120 }}
          />
        </DialogContent>
        <DialogActions
          style={{
            padding: '24px 24px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'flex-start',
          }}>
          <Button onClick={handleClose} color="secondary" variant="outlined" disabled={loading} size="medium" style={{ minWidth: 100, marginTop: 12 }}>
            Cancel
          </Button>
          <Button onClick={handleConfirm} color="primary" variant="contained" disabled={loading || !amount} size="medium" style={{ minWidth: 100, marginTop: 12 }} autoFocus>
            Confirm
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddToAllButton;
